export default "__VITE_ASSET__CL0KE4yx__"